import { loginPending, loginSuccess, loginFail } from '../../redux/features/loginSlice';
import { otpPending, otpSuccess, otpFail, otpValidatePending, otpValidateSuccess, otpValidateFail, getUserPending, getUserSuccess, getUserFail, updatePasswordPending, updatePasswordSuccess, updatePasswordFail } from '../../redux/features/forgotPasswordSlice';
import { userLogin, userTokenAuthenticate, sendOtp, validateOtp, getUsersForMobileNo, updateUsersPasswordForMobileNo } from '../apis/userApi';

export const userLoginAction = (loginDetails, apiToken) => async (dispatch) => {
    try {
        dispatch(loginPending());
        const result = await userLogin(loginDetails, apiToken);
        if (result.status === "Ok") {
            dispatch(loginSuccess({ userToken: result.data.userToken, userData: result.data.user, userBranchStore: result.data.user.userBranchStore }));
        } else {
            dispatch(loginFail(result.errorMessage))
        }
        return result

    } catch (error) {
        dispatch(loginFail(error.message));
    }
};

export const userTokenAuthenticateAction = (userToken) => async (dispatch) => {
    try {
        const result = await userTokenAuthenticate(userToken);
        return result

    } catch (error) {
        dispatch(loginFail(error.message));
    }
};

export const sendOtpAction = (mobileNoDetails, apiToken) => async (dispatch) => {
    try {
        dispatch(otpPending());
        const result = await sendOtp(mobileNoDetails, apiToken);
        if (result.status === "Ok") {
            dispatch(otpSuccess(mobileNoDetails));
        } else {
            dispatch(otpFail(result.errorMessage))
        }
        return result

    } catch (error) {
        //dispatch(otpFail(error.message));
        return { status: 'Error', errorMessage: error.message };
    }
};

export const validateOtpAction = (otpDetails, apiToken) => async (dispatch) => {
    try {
        dispatch(otpValidatePending());
        const result = await validateOtp(otpDetails, apiToken);
        if (result.status === "Ok") {
            dispatch(otpValidateSuccess());
        } else {
            dispatch(otpValidateFail(result.errorMessage))
        }
        return result

    } catch (error) {
        dispatch(otpValidateFail(error.message));
        return { status: 'Error', errorMessage: error.message };
    }
};

export const getUsersAction = (filters, apiToken) => async (dispatch) => {
    try {
        dispatch(getUserPending());
        const result = await getUsersForMobileNo(filters, apiToken);
        if (result.status === "Ok") {
            dispatch(getUserSuccess());
        } else {
            dispatch(getUserFail(result.errorMessage))
        }
        return result

    } catch (error) {
        //dispatch(loginFail(error.message));
        return { status: 'Error', errorMessage: error.message };
    }
};

export const updateUsersPasswordForMobileNoAction = (passwordDetails, apiToken) => async (dispatch) => {
    try {
        dispatch(updatePasswordPending());
        const result = await updateUsersPasswordForMobileNo(passwordDetails, apiToken);
        if (result.status === "Ok") {
            dispatch(updatePasswordSuccess());
        } else {
            dispatch(updatePasswordFail(result.errorMessage))
        }
        return result
    } catch (error) {
        //dispatch(loginFail(error.message));
        return { status: 'Error', errorMessage: error.message };
    }
};
